import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { useMemo } from 'react';
import { MDBBtn, MDBCheckbox, MDBIcon } from 'mdb-react-ui-kit';

export interface SalesReportHeaderProps {
    onExportExcel: () => void;
    onExportCSV: () => void;
    filter: {
        cash: boolean;
        card: boolean;
        total: boolean;
    };
    onToggleFilter: (valueType: 'cash' | 'card' | 'total') => void;
}

export default function SalesReportHeader({
    onExportCSV,
    onExportExcel,
    filter,
    onToggleFilter,
}: SalesReportHeaderProps) {
    const { t } = useTranslation();
    const { innerWidth } = useWindowSize();
    const mobile = useMemo(() => innerWidth < 600, [innerWidth]);

    return (
        <div className="ms-2 d-flex align-items-center flex-wrap">
            <MDBBtn color="link" onClick={onExportExcel} hidden={mobile}>
                <MDBIcon icon="file-excel" color="success" className="me-1" />
                <span>{t('export_to_excel')}</span>
            </MDBBtn>
            <MDBBtn color="link" onClick={onExportCSV} hidden={mobile}>
                <MDBIcon icon="file-csv" color="success" className="me-1" />
                <span>{t('export_to_csv')}</span>
            </MDBBtn>
            <div className="d-flex align-items-center flex-wrap ps-2">
                <MDBIcon icon="filter" color="primary" className="me-2" />
                <MDBCheckbox
                    label={t('cash_value')}
                    name="sales-report-cash"
                    type="checkbox"
                    checked={filter.cash}
                    id="sales-report-cash"
                    onChange={() => onToggleFilter('cash')}
                    className="me-3 mb-0"
                    inline
                />
                <MDBCheckbox
                    label={t('card_value')}
                    name="sales-report-card"
                    type="checkbox"
                    checked={filter.card}
                    id="sales-report-card"
                    onChange={() => onToggleFilter('card')}
                    className="me-3 mb-0"
                    inline
                />
                <MDBCheckbox
                    label={t('total_value')}
                    name="sales-report-total"
                    type="checkbox"
                    checked={filter.total}
                    id="sales-report-total"
                    onChange={() => onToggleFilter('total')}
                    className="me-2 mb-0"
                    inline
                />
            </div>

            <MDBBtn
                tag="a"
                color="none"
                onClick={onExportExcel}
                className="p-2"
                hidden={!mobile}
            >
                <MDBIcon
                    icon="file-excel"
                    size="lg"
                    color="success"
                    className="me-1"
                />
            </MDBBtn>
            <MDBBtn
                tag="a"
                color="none"
                onClick={onExportCSV}
                className="p-2"
                hidden={!mobile}
            >
                <MDBIcon
                    icon="file-csv"
                    size="lg"
                    color="success"
                    className="me-1"
                />
            </MDBBtn>
        </div>
    );
}
